/*
 * Web api settings
 */

export const locationsAPIurls = {
    single: '/api/mapLocations/findlocation',
    all: '/api/mapLocations/findalllocations',
    info: '/ContactData/',
};

export const requestNamesMap = {
    latitude: 'Latitude',
    longitude: 'Longitude',
    type: 'Type',
    id: 'Guid',
    name: 'Name',
    country: 'Country',
    url: 'Url',
};

/*
 * Google maps settings
 */

export const googleMapsAPIurl =
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyAURrPQGSKNcWhRPaO8UVq4A5EZ3V6QAXw';

export const googleMapsWebUrl =
    'https://www.google.com/maps/search/?api=1&query=';

export const markerStyleTypeMap = {
    office: 'office',
    Port: 'port',
    'ShipAgencyOffice': 'office',
    'HeadOffice': 'office',
    'ShipManagementOffice': 'office',
    'MaritimeLogisticsOffice': 'office',
    'CrewRecruitmentOffice': 'office',
};

export const officeNameMap = {
    office: 'Office',
    Port: 'Port',
    'ShipAgencyOffice': 'Port Services Office',
    'HeadOffice': 'Headquarter',
    'ShipManagementOffice': 'Ship Management Office',
    'MaritimeLogisticsOffice': 'Maritime Logistics Office',
    'CrewRecruitmentOffice': 'Manning Services Office',
};

export const officeIconClassMap = {
    office: 'sa',
    Port: 'port',
    'Port Agency Office': 'sa',
    'Headquarter': 'hq',
    'Ship Management Office': 'sm',
    'Maritime Logistics Office': 'ml',
    'Manning Services Office': 'ms',
};

export const markerStyles = {
    office: {
        path: 'M12 0C5.383 0 0 5.083 0 11.333c0 6.013 10.91 21.685 11.374 22.348A.766.766 0 0 0 12 34c.252 0 .486-.12.626-.319C13.09 33.018 24 17.346 24 11.333 24 5.084 18.617 0 12 0zm0 16c-2.757 0-5-2.244-5-5s2.243-5 5-5 5 2.244 5 5-2.243 5-5 5z',
        fillColor: '#345888',
        fillOpacity: 1,
        scale: 1,
        strokeWeight: 1,
        strokeColor: '#ffffff',
        anchor: {x: 12, y: 34},
    },
    port: {
        path: 'M12 0C5.383 0 0 5.083 0 11.333c0 6.013 10.91 21.685 11.374 22.348A.766.766 0 0 0 12 34c.252 0 .486-.12.626-.319C13.09 33.018 24 17.346 24 11.333 24 5.084 18.617 0 12 0zm0 16c-2.757 0-5-2.244-5-5s2.243-5 5-5 5 2.244 5 5-2.243 5-5 5z',
        fillColor: '#ffffff',
        fillOpacity: 1,
        scale: 1,
        strokeWeight: 1,
        strokeColor: '#345888',
        anchor: {x: 12, y: 34},
    },
};

export const mapStyles = [
    {
        featureType: 'all',
        stylers: [
            {
                saturation: '-60',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
];

export const mapZoom = {
    small: 10,
    large: 4,
};

export const clusterStyles = [{
    textColor: 'white',
    textSize: 12,
    url: '/Static/prod/images/Contacts-locations/Pin--aggregated.png',
    height: 30,
    width: 38,
    anchor: {x: 19, y: 0},
    scale: 1,
    strokeWeight: 1,
    strokeColor: '#ffffff',
}];

export const clusterOptions = {
    gridSize: 100,
    styles: clusterStyles,
    minZoom: mapZoom.large,
    maxZoom: mapZoom.small,
};

export const delay = 0;